import React from 'react'

export default function NFTs() {
  return (
    <div>NFTs</div>
  )
}
